export const getRecordNotFoundAttributeForTable = (recordNotFoundAttribute, formatMessage, codeFieldInfo) => {
    if (!recordNotFoundAttribute ||  !formatMessage) {
        return { id: '', label: '' };
    }
    const displayLabelId = recordNotFoundAttribute?.displayLabelId ?? '';
    const ret = {
        id: `${recordNotFoundAttribute?.recordValue?.value}_noRecordFound`,
        label: displayLabelId ? formatMessage({ id: displayLabelId }) : displayLabelId,
    };

    if (codeFieldInfo) {
        ret[codeFieldInfo.codeFieldPath] = recordNotFoundAttribute?.recordValue?.code;
    }

    return ret;
};